<template>
  <div class="exchange-dialog-container">
    <el-dialog
      :title="$t('Datalang.home_redemption')"
      :visible="visibleExchange"
      append-to-body
      center
      :width="getIsMobile ? '88vw' : '600px'"
      custom-class="exchange-dialog-container"
      :before-close="hideExchange">
      <div class="exchange-dialog-content" v-loading="isLoading">
        <div class="is-empty" v-if="medalList.length === 0 && !isLoading">
            <img class="img" :src="require('@/assets/nodata/nodata.png')" />
            <span class="txt">{{ $t("Datalang.Invite_TITLE_nodatanow") }}</span>
        </div>
        <div class="exchange-dialog-content-item" v-for="(item, index) in medalList" :key="item.sid">
          <div class="item-thumb">
            <img :src="$utils.returnImgUrl(item.image)" alt="">
          </div>
          <div class="item-info">
            <div class="item-info-title">
              {{ $t("Datalang.home_victor_mark") }} *{{ item.requiredCount || 0 }}
            </div>
            <div class="item-info-amount">
              {{ $t("Datalang.VIPSpin_Spin_Prizes") }} {{ coinMap[item.coinCode]?.symbol || '' }} <span>{{ divideAccuracy(item.value, coinMap[item.coinCode]?.accuracy || '') }}</span>
            </div>
          </div>
          <div class="item-right">
            <button 
              v-if="item.status === 'REWARD_STATUS_UNSENT'" 
              class="btn btn-receive"
              @click="handleReceive(item, index)">
              {{ $t("Datalang.newly_claim") }}
            </button>
            <button 
              v-if="item.status === 'REWARD_STATUS_NOT_MEET_CONDITION'" 
              class="btn btn-unfinished">
              {{ $t("Datalang.task_word_1") }}
            </button>
            <button 
              v-if="item.status === 'REWARD_STATUS_SENT'" 
              class="btn btn-completed">
              {{ $t("Datalang.home_Completed") }}
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible="visibleMedal"
      append-to-body
      :fullscreen="getIsMobile"
      :width="getIsMobile ? '100vw' : '600px'"
      :show-close="!getIsMobile"
      custom-class="medal-custom-dialog-container"
      :before-close="hideMedal">
      <template #title>
        <div class="medal-dialog-title">
          <img v-if="getIsMobile" class="return" @click="hideMedal" src="@/assets/exchange/fanhui_btn.png" alt="return" srcset />
          <div>{{ $t("Datalang.home_medals_total") }}</div>
        </div>
      </template>
       <div class="medal-dialog-content" :class="{ pc: !getIsMobile }" v-loading="isLoading">
        <div class="is-empty" v-if="medalGridList.length === 0 && !isLoading">
          <img class="img" :src="require('@/assets/nodata/nodata.png')" />
          <span class="txt">{{ $t("Datalang.Invite_TITLE_nodatanow") }}</span>
        </div>
        <template v-else>
          <div class="medal-count-display">{{ totalCount }}</div>
          <div class="medal-grid-container">
            <div class="medal-grid">
              <div class="medal-grid-item" v-for="(medal, index) in medalGridList" :key="index">
                <div class="medal-icon">
                  <img :src="$utils.returnImgUrl(medal.isUnlocked ? medal.unlockIcon : medal.lockedIcon)" :alt="medal.medalName">
                </div>
                <div class="medal-name">{{ medal.medalName }}</div>
                <div class="medal-quantity">X{{ medal.count }}</div>
              </div>
            </div>
          </div>
        </template>
       </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMedalExchangeList, getMedalList, medalExchange } from '@/lobby_common/api/medal_gen.js'
import {
  divideAccuracy,
  formatLang,
} from "@/lobby_common/utils/utils.js";
export default {
  name: 'medalDialog',
  data() {
    return {
      visible: false,
      visibleExchange: false,
      visibleMedal: false,
      isLoading: false,
      medalList: [],
      medalGridList: [],
      totalCount: 0
     }
   },
  computed: {
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    getToken() {
      return this.$store.getters.taken;
    },
    userData() {
      return this.$store.getters.user || {};
    },
    useraccuracy() {
      return this.userData.accuracy;
    },
    userCoinCode() {
      return this.userData.coinCode;
    },
    userCoinSymbol() {
      return this.userData.coinSymbol;
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.allCoinList || [];
    },
    coinMap() {
      return this.coinList.reduce((acc, coin) => {
        acc[coin.coinCode] = coin;
        return acc;
      }, {});
    },
  },
  methods: {
    divideAccuracy,
    formatLang,
    async showExchange() {
      if (!this.getToken) {
        return
      }
      try {
        this.isLoading = true
        const res = await getMedalExchangeList({})
        if (res.code === 0) {
          this.medalList = res.data.exchangeList || []
        }
        this.visibleExchange = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async showMedal() {
      if (!this.getToken) {
        return
      }
      try {
        this.isLoading = true
        const res = await getMedalList({})
        if (res.code === 0) {
          this.medalGridList = res.data.medalList || []
          this.totalCount = res.data.totalCount || 0
        }
        this.visibleMedal = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    hideExchange() {
      this.visibleExchange = false
    },
    hideMedal() {
      this.visibleMedal = false
    },
    async handleReceive(item, index) {
      // 处理领取逻辑
      console.log('领取奖励:', item)
      // 可以在这里调用API领取奖励，然后更新状态
      if (item.status === 'REWARD_STATUS_SENT') {
        return
      }
      this.$eventPost("betting_rank_exchange_claim")
      try {
        const res = await medalExchange({
          sid: item.sid
        })
        if (res.code === 0) {
          this.$message.success(this.$t("Datalang.task_word_13"));
          this.medalList.splice(index, 1, {
            ...item,
            status: 'REWARD_STATUS_SENT'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style scoped lang="scss">
:deep(.exchange-dialog-container) {
  .el-dialog__body{
    padding: 15px 20px;
  }
}
.exchange-dialog-content {
  max-height: 60vh;
  overflow-y: auto;
}

.is-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .img {
    width: 100px;
    height: auto;
  }
  .txt {
    margin-top: 10px;
    font-size: 14px;
  }
}

.exchange-dialog-content-item {
  display: flex;
  align-items: center;
  border-radius: var(--border-radius-100);
  margin-bottom: 12px;
}

.item-thumb {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-2201);
	border-radius: var(--radius-200);
	border: solid 1px var(--border-color-100);
}

.item-thumb img {
  width: 40px;
  height: auto;
  object-fit: cover;
}

.item-info {
  flex: 1;
  min-width: 0;
}

.item-info-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--font-color-100);
  margin-bottom: 4px;
  line-height: 1.4;
  @include textOverflow(1);
}

.item-info-amount {
  font-size: 12px;
  color: var(--font-color-900);
}

.item-info-amount span {
  font-weight: 600;
  color: var(--font-color-1500);
}

.item-right {
  flex-shrink: 0;
  margin-left: 10px;
}

.btn-receive {
  @include buttonPrimary(small);
}
.btn-unfinished {
  @include button300(small);
}
.btn-completed {
  @include buttonYellow(small);
}


 // 累计勋章
 :deep(.medal-custom-dialog-container) {
   .el-dialog__header{
     height: 58px;
     box-sizing: border-box;
     padding: 0;
     .el-dialog__headerbtn{
      z-index: 10;
      &:hover .el-dialog__close{
        color: var(--font-color-100);
      }
     }
   }
   .el-dialog__body {
     padding: 0;
   }
 }
 
 .medal-dialog-title {
   position: absolute;
   left: 0;
   top: 0;
   width: 100%;
   z-index: 9;
   box-sizing: border-box;
   display: flex;
   align-items: flex-end;
   justify-content: center;
   color: var(--font-color-200);
   background: var(--background-200);
   font-size: 18px;
   padding: 15px;
 
   .return {
     position: absolute;
     left: 12px;
     bottom: 9px;
     width: 28px;
     cursor: pointer;
   }
 }

 .medal-dialog-content {
   height: calc(100vh - 58px);
   height: calc(100svh - 58px);
   box-sizing: border-box;
   display: flex;
   flex-direction: column;
   &.pc{
    height: calc(600px - 58px);
   }
 }

 .medal-count-display {
   text-align: center;
   font-size: 32px;
   font-weight: bold;
   color: var(--font-color-100);
   padding: 20px 0;
  //  background: var(--background-100);
 }

 .medal-grid-container {
   flex: 1;
   overflow-y: auto;
   padding: 0 10px 10px;
 }

 .medal-grid {
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   padding-bottom: 20px;
 }

 .medal-grid-item {
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-bottom: 20px;
 }

 .medal-icon {
   width: 78px;
   height: 78px;
   margin-bottom: 8px;
   overflow: hidden;
   display: flex;
   align-items: center;
   justify-content: center;
   background: var(--background-2201);
   border-radius: var(--radius-200);
   border: solid 1px var(--border-color-100);
   
   img {
     width: 62px;
     height: auto;
     object-fit: cover;
   }
 }

 .medal-name {
   font-size: 12px;
   font-weight: 500;
   color: var(--font-color-900);
   text-align: center;
   margin-bottom: 4px;
   line-height: 1.2;
   @include textOverflow(1);
 }

 .medal-quantity {
   font-size: 14px;
   font-weight: 600;
   color: var(--font-color-100);
   text-align: center;
 }
</style>